<template functional>
  <div
    class="d-flex flex-direction-row justify-content-center"
    :style="
      props.row.evolutionary_stage < 150
        ? 'background:green; color:white;'
        : props.row.evolutionary_stage > 250
        ? 'background:red; color:black;'
        : 'background:#F5BB27; color:black;'
    "
  >
    {{ props.row.evolutionary_stage }}
  </div>
</template>
<script>
export default {
  name: 'EvolutionaryStage',
};
</script>
